import GroupFireBolt from './group-firebolt';

export default GroupFireBolt;
